import { createAndRedirectToNewApp } from '../../../common/components/utility';

export class WhatYouSeeIsWhatYouGetEditor {
    store = null;

    async init({ store }) {
        this.store = store;
        await this._initActions();
    }

    async _initActions() {
        const enterAppBuilderButton: HTMLButtonElement = document.querySelector('.what-you-see-is-what-you-get-editor-action-control--app-builder');

        if (enterAppBuilderButton !== null) {        
            enterAppBuilderButton.addEventListener('click', async (event) => {
                const createAndRedirectToNewAppOptions = {
                    store: this.store
                }

                await createAndRedirectToNewApp(createAndRedirectToNewAppOptions);
            })
        }
    }
}